module.exports = __webpack_public_path__ + "img/live-title.ffcb9d58.png";